export default __webpack_public_path__ + "static/media/red-dot.44fbcb6e.svg";